/**
 * Centralized route constants for the application
 * Import and use these constants throughout your app to maintain consistency
 *
 * Usage example:
 * import { ROUTES } from '@/lib/routes';
 * <Link href={ROUTES.counselling.relationships}>Relationships</Link>
 * <Link href={ROUTES.resources.counsellingBlogPost('my-slug')}>Blog Post</Link>
 */

export const ROUTES = {
  // Main pages
  home: "/",
  about: "/about",
  booking: "/booking",
  contact: "/contact",
  faq: "/counselling-faq",

  // Counselling routes
  counselling: {
    main: "/counselling",
    angerManagement: "/anger-management",
    griefAndLoss: "/grief-loss",
    careerCounselling: "/career-counselling",
    relationships: "/relationships",
    depressionAndAnxiety: "/depression-anxiety",
  },

  // Life Coach routes
  lifeCoach: {
    main: "/life-coach",
    changingHabits: "/changing-habits",
    focusAndProductivity: "/focus-productivity",
    publicSpeaking: "/public-speaking",
    timeManagement: "/time-management",
    selfEsteemAndConfidence: "/self-esteem-confidence",
  },

  // Resources routes
  resources: {
    counsellingBlog: "/wellness-blog",
    counsellingBlogPost: (slug: string) => `/${slug}`,
    counsellingPodcast: "/podcast",
    counsellingPodcastPost: (slug: string) => `/${slug}`,
  },

  // Courses routes
  courses: {
    selfDiscovery247: "/24seven-self-discovery",
  },

  // Allied Health routes
  alliedHealth: {
    main: "/allied-health",
    occupationalTherapy: "/occupational-therapy",
    psychology: "/psychology",
  },

  // Team routes
  team: {
    main: "/teams",
    member: (slug: string) => `/teams/${slug}`,
  },

  // Legal routes
  privacyPolicy: "/privacy-policy",
  termsOfUse: "/terms-of-use",
} as const;

// Helper type to get all possible route paths
export type Route = typeof ROUTES;
